
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 359.5 633.79\" id=\"circle-template-left\" ><title>Asset 5</title><g data-name=\"Layer 2\"><path d=\"M42.61 316.89C42.61 141.88 184.49 0 359.5 0H0v633.79h359.2c-174.87-.17-316.59-141.98-316.59-316.9z\" data-name=\"Layer 1\"/></g></symbol>";
module.exports = sprite.add(image, "circle-template-left");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circle-template-left.svg
// module id = 301
// module chunks = 1